<template>
  <header class="sticky">
    <div class="d-flex align-items-center px-3 px-md-4 py-3" style="min-height: 56px;">
      <router-link class="navbar-brand m-0 p-0 d-inline-flex align-items-center" :to="{name: 'HomePage'}" replace style="text-decoration: none;">
        <span class="stella-logo-text" style="font-size: 24px;">✨ stella✦</span>
      </router-link>
    </div>
    <loading-modal :is-loading="isLoading"></loading-modal>
  </header>
</template>

<script>

import LoadingModal from "@/components/module/shared/LoadingModal";

export default {
  name: "HeaderMenu",
  props: ['isLoading','isClose'],
  components: {LoadingModal}
}
</script>


